module.exports = __webpack_public_path__ + "static/img/3.cd2d1f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/3.png
// module id = yMJq
// module chunks = 202